import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'gatsby';
import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../components/layouts/HomeLayout';
import SEO from '../components/seo';

import '../components/home/style.scss';

import home_ticket from '../components/home/home-tickets.png';
import home_callout from '../components/home/home-callout.png';

export const Home = ({ user, notification, actions }) => {
    return (
        <Layout user={user} notification={notification} actions={actions}>
            <SEO title="Home" />
            <HomeInner />
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);

export const HomeInner = () => {
    return (
        <div className="home">
            <div className="flex-row-container py-5">
                <img
                    src={home_ticket}
                    className="img-fluid"
                    alt="Holiday Promotion tickets"
                />
                <Link to={'/enter'}>
                    <img
                        src={home_callout}
                        className="img-fluid"
                        alt="Holiday Promotion tickets"
                    />
                </Link>
            </div>
        </div>
    );
};
